/* eslint-disable jsx-a11y/heading-has-content */
import classnames from 'clsx'
import { node, oneOfType, string } from 'prop-types'

import SubmenuCardTitle from 'views/components/organisms/HeaderNew/SubmenuCardTitle'

import './SubmenuCard.scss'

const SubmenuCard = ({ children, title, cardClasses, boxClasses }) => {
  const cardClassNames = classnames(
    'o-SubmenuCard',
    'u-no-padding--left@medium',
    'u-no-padding--sides@small-tiny',
    'u-no-padding--bottom@small-tiny',
    cardClasses
  )

  const headingClasses = {
    'u-visuallyhidden@small-tiny': !title,
  }

  const cardBodyClasses = classnames(
    'a-box',
    'a-box--white',
    'u-no-border-radius@small-tiny',
    'u-padding-large@small-tiny',
    'l-flex',
    'l-flex--vertical-stretch',
    boxClasses
  )

  return (
    <div className={cardClassNames}>
      <div className="u-visuallyhidden@medium">
        <SubmenuCardTitle classes={classnames(headingClasses)}>
          {title}
        </SubmenuCardTitle>
      </div>
      <div className={cardBodyClasses}>{children}</div>
    </div>
  )
}

SubmenuCard.propTypes = {
  title: oneOfType([node, string]),
  children: node.isRequired,
  cardClasses: string,
  boxClasses: string,
}

SubmenuCard.defaultProps = {
  title: undefined,
  cardClasses: undefined,
  boxClasses: undefined,
}

export default SubmenuCard
